/* global axios */
// NOTICE: KAPTION-INTEGRATION
// smart-availability.API.1 — who can take work right now, per person and per team, as the
// account's availability endpoint answers it (through the platform's cache).
//
//   GET /api/v1/accounts/:accountId/kaption_smart_availability?inbox_id=&conversation_id=
//
// Documented for other clients (the mobile app is next) in docs/api/kaption-smart-availability.md.
import ApiClient from './ApiClient';

class KaptionSmartAvailability extends ApiClient {
  constructor() {
    super('kaption_smart_availability', { accountScoped: true });
  }

  fetch({ inboxId, conversationId }) {
    return axios.get(this.url, {
      params: { inbox_id: inboxId, conversation_id: conversationId },
    });
  }
}

export default new KaptionSmartAvailability();
